(function () {
  function isIos() {
    return (
      /iphone|ipad|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  function isAndroid() {
    return /android/i.test(navigator.userAgent);
  }

  function isStandalone() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  }

  function deviceKind() {
    if (isStandalone()) return 'done';
    if (isIos()) {
      if (/ipad/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return 'ipad';
      }
      return 'iphone';
    }
    if (isAndroid()) return 'android';
    if (navigator.maxTouchPoints > 1) return 'android';
    return 'other';
  }

  function deviceLabel(kind) {
    if (kind === 'iphone') return 'We see you’re on an iPhone';
    if (kind === 'ipad') return 'We see you’re on an iPad';
    if (kind === 'android') return 'We see you’re on Android';
    if (kind === 'done') return 'Already saved on this device';
    return 'Follow these steps on your phone or tablet';
  }

  function guideKey(kind) {
    if (kind === 'iphone' || kind === 'ipad') return 'ios';
    if (kind === 'android') return 'android';
    if (kind === 'done') return 'done';
    return 'other';
  }

  function applyGuide(root) {
    if (!root) return;
    var kind = deviceKind();
    var key = guideKey(kind);
    var label = root.querySelector('[data-uc-device-label]');
    if (label) {
      label.hidden = false;
      label.textContent = deviceLabel(kind);
    }
    root.querySelectorAll('[data-uc-guide]').forEach(function (el) {
      el.hidden = el.getAttribute('data-uc-guide') !== key;
    });
  }

  if (!customElements.get('uc-shortcut-drawer')) {
    customElements.define(
      'uc-shortcut-drawer',
      class UcShortcutDrawer extends HTMLElement {
        constructor() {
          super();
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onBackdropClick = this.onBackdropClick.bind(this);

          var closeButton = this.querySelector('[data-uc-shortcut-close]');
          if (closeButton) {
            closeButton.addEventListener('click', () => this.hide());
          }

          this.addEventListener('click', this.onBackdropClick);
        }

        connectedCallback() {
          applyGuide(this);
        }

        onBackdropClick(event) {
          if (event.target === this) this.hide();
        }

        onKeyDown(event) {
          if (event.key === 'Escape') this.hide();
        }

        hide() {
          this.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
          document.removeEventListener('keydown', this.onKeyDown);
          if (this.focusElement && typeof this.focusElement.focus === 'function') {
            this.focusElement.focus();
          }
        }

        show(focusElement) {
          applyGuide(this);
          this.focusElement = focusElement || document.activeElement;
          this.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
          document.addEventListener('keydown', this.onKeyDown);
          var closeButton = this.querySelector('[data-uc-shortcut-close]');
          if (closeButton) closeButton.focus();
        }
      }
    );
  }

  function getDrawer() {
    return document.querySelector('uc-shortcut-drawer');
  }

  function openFrom(trigger) {
    var drawer = getDrawer();
    if (!drawer || typeof drawer.show !== 'function') return;
    drawer.show(trigger);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-uc-shortcut-open]');
    if (!trigger) return;
    event.preventDefault();
    openFrom(trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyGuide(getDrawer());
    });
  } else {
    applyGuide(getDrawer());
  }
})();
